export default __webpack_public_path__ + "static/media/marketing-real-estate-welcome-bonus-background.24a51aee.svg";